<!--  -->
<template>
<div>
  <div class="map-title">数字化资源加工中心</div>
  <div class="map-container" id="china-map">
    <template>
      <img src="../../assets/image/china.png" alt="加工中心分布" style="width:700px;height:506px;opacity: 0.25;padding-top: 10px;"
        class="china-bg animate__animated animate__zoomIn">
      <div class="data-wrap">
        <ul class="center-ul">
          <li v-for="(item, key) in centerList" class="center-item" :key="key" @click="showDialog(item)">
            {{item.name}}
          </li>
        </ul>
      </div>
      <el-dialog :visible.sync="dialogVisible" class="timeline-dialog" width="800px" :title="title"
        :append-to-body="true" :close-on-click-modal="true">
        <div v-if="images.length === 1">
          <img :src="images[0]" alt="" style="width: 100%;height: auto;">
        </div>
        <el-carousel :interval="4000" height="31.25rem" v-else class="timeline-carousel">
          <el-carousel-item v-for="(item, key) in images" :key="key">
            <img :src="item" style="height: auto;width: 100%;" />
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
    </template>
  </div>
</div>
</template>

<script>
import data from "@/mock/numhis_center.json";
export default {
  data() {
    return {
      centerList: data,
      dialogVisible: false,
      showBg: false,
      title: "",
      images: []
    };
  },
  mounted() {
    this.setAnimation();
  },
  methods: {
    showDialog(item) {
      this.title = item.name;
      this.images = item.images;
      this.dialogVisible = true;
    },
    setAnimation() {
      const io = new IntersectionObserver(
        data => {
          if (data[0].intersectionRatio === 1) {
            this.render();
            io.disconnect();
          }
        },
        {
          threshold: [0, 1]
        }
      );

      io.observe(document.getElementById("china-map"));
    },
    render() {
      this.showBg = true;
    }
  }
};
</script>
<style lang='scss' scoped>
.map-container {
  width: 700px;
  height: 680px;
  position: relative;

  .china-bg {
    width: 100%;
    height: 100%;
  }
}

.map-title {
  text-align: center;
  padding: 20px 0;
  font-weight: bold;
  font-family: 'Microsoft YaHe';
  color: #333;
  font-size: 18px;
}

.data-wrap {
  .center-ul {
    position: absolute;
    left: 0;
    top: 150px;
    width: 100%;
    height: 100%;
    color: #000000;
    margin-left: 100px;
    /*background: rgba(0, 0, 0, 0.1);*/
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 20px;
    box-sizing: border-box;
    .center-item:hover {
      transform: scale(1.1);
    }

    .center-item {
      width: 200px;
      height: 30px;
      line-height: 30px;
      position: relative;
      cursor: pointer;

      &::before {
        content: " ";
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: yellow;
        border: 2px solid #fff;
        vertical-align: middle;
      }

      &:hover::before {
        transform: scale(1.5);
        transition: all 0.5s;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/china.vue